import { Flex, Subheading, Text } from "@wayflyer/flyui";

type DescriptionTextProps = {
  step: string;
  heading: string;
  content: string;
};

export const DescriptionText = ({ step, heading, content }: DescriptionTextProps) => (
  <Flex direction="column" align="flex-start" justify="center" gap="1">
    <Flex direction="column" gap="1">
      <Text color="placeholder">{step}</Text>
      <Subheading>{heading}</Subheading>
    </Flex>
    <Text>{content}</Text>
  </Flex>
);
